module.exports = __webpack_public_path__ + "img/magento-services-integration.ae2c19d9.jpg";